function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from "react";
import { SortableContainer } from "react-sortable-hoc";

function CustomTheadComponent(props) {
  var headerColumns = props.children.props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "rt-thead " + props.className,
    style: props.style
  }, /*#__PURE__*/React.createElement("div", {
    className: "rt-tr"
  }, headerColumns.map(function (column) {
    // if a column is marked as immovable just return regular column
    if (column.props.immovable === "true") return column; // keeps track of hidden columns here so columnIndex might not equal i

    return column;
  })));
}

var SortableCustomTheadComponent = SortableContainer(CustomTheadComponent);

var SortableColumns = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SortableColumns, _Component);

  function SortableColumns() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "shouldCancelStart", function (e) {
      var className = e.target.className; // if its an svg then it's a blueprint icon

      return e.target instanceof SVGElement || className.indexOf("rt-resizer") > -1;
    });

    _defineProperty(_assertThisInitialized(_this), "onSortEnd", function (_ref) {
      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;

      _this.props.moveColumn({
        oldIndex: oldIndex,
        newIndex: newIndex
      });
    });

    return _this;
  }

  var _proto = SortableColumns.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(SortableCustomTheadComponent, _extends({}, this.props, {
      lockAxis: "x",
      axis: "x",
      distance: 10,
      helperClass: "above-dialog",
      shouldCancelStart: this.shouldCancelStart,
      onSortEnd: this.onSortEnd
    }));
  };

  return SortableColumns;
}(Component);

export default SortableColumns;